
import { Component, DOCUMENT, ElementRef, inject, OnInit, ViewChild } from "@angular/core";
import { LayoutAlignDirective, LayoutDirective } from "@ngbracket/ngx-layout/flex";
import { DialogComponent } from "@tylertech/forge";
import { DialogRef, ForgeButtonModule, ForgeScaffoldModule, ForgeToolbarModule } from "@tylertech/forge-angular";
import { Key, ModifierKey } from "@tylertech/tyler-api-types";
import { KeyHandlerId, KeyHandlerService, ShortcutGroupKey, ShortcutInfo } from "../../../services";
import { ShortcutGroupComponent } from "./shortcutGroup.component";

interface ShortcutGroup
{
    readonly name: ShortcutGroupKey | string;
    readonly shortcuts: Array<ShortcutInfo>;
}

// TODO - why aren't we just requiring the metadata date input manage the registration of these during its onInit and onDestroy lifecycle hooks
const dateInputKeys: Array<ShortcutInfo> = [

    { Group: ShortcutGroupKey.DateInput, Keys: "bow", Description: "Beginning of Week" },
    { Group: ShortcutGroupKey.DateInput, Keys: "eow", Description: "End of Week" },
    { Group: ShortcutGroupKey.DateInput, Keys: "bom", Description: "Beginning of Month" },
    { Group: ShortcutGroupKey.DateInput, Keys: "eom", Description: "End of Month" },
    { Group: ShortcutGroupKey.DateInput, Keys: "bolm", Description: "Beginning of Last Month" },
    { Group: ShortcutGroupKey.DateInput, Keys: "eolm", Description: "End of Last Month" },
    { Group: ShortcutGroupKey.DateInput, Keys: "boq", Description: "Beginning of Quarter" },
    { Group: ShortcutGroupKey.DateInput, Keys: "eoq", Description: "End of Quarter" },
    { Group: ShortcutGroupKey.DateInput, Keys: "boy", Description: "Beginning of Year" },
    { Group: ShortcutGroupKey.DateInput, Keys: "eoy", Description: "End of Year" },
    { Group: ShortcutGroupKey.DateInput, Keys: "bolq", Description: "Beginning of Last Quarter" },
    { Group: ShortcutGroupKey.DateInput, Keys: "eolq", Description: "End of Last Quarter" },
    { Group: ShortcutGroupKey.DateInput, Keys: "boly", Description: "Beginning of Last Year" },
    { Group: ShortcutGroupKey.DateInput, Keys: "eoly", Description: "End of Last Year" },

];

@Component({
    selector: "shortcut-legend",
    templateUrl: './shortCutLegend.tmpl.html',
    styleUrls: [
        "./shortCutLegend.component.scss"
    ],
    imports: [
        LayoutAlignDirective,
        LayoutDirective,
        ForgeButtonModule,
        ForgeScaffoldModule,
        ForgeToolbarModule,
        ShortcutGroupComponent,
    ]
})
export class ShortCutLegendComponent
    implements OnInit
{
    private readonly document = inject<Document>(DOCUMENT);
    private readonly dialogRef = inject<DialogRef>(DialogRef);
    private readonly keyHandlerService = inject(KeyHandlerService);

    @ViewChild("dialog") readonly dialog: ElementRef<DialogComponent>;

    groupedShortcuts: Array<ShortcutGroup>;

    ngOnInit(): void
    {
        const shortcuts = this.keyHandlerService.getListenerKeys();

        const groupedShortcuts = shortcuts.reduce(
            (groups: Array<ShortcutGroup>, keyHandlerId: KeyHandlerId) =>
            {
                // FIXME(DO-4549) - We never create a keyHandlerId that is 5 strings delimited by pipes ("|")....
                const [_id, key, modifier, groupOrDescription, description] = keyHandlerId.split("|");
                const groupStr = description
                    ? groupOrDescription as ShortcutGroupKey
                    : ShortcutGroupKey.View;

                let group = groups.find(x => x.name === groupStr);
                if (!group)
                {
                    group = {
                        name: groupStr,
                        shortcuts: []
                    };
                    groups.push(group);
                }

                group.shortcuts.push({
                    Group: groupStr,
                    Description: description ?? groupOrDescription,
                    Keys: `${this.getModifier(parseInt(modifier))} + ${this.getKey(parseInt(key))}`
                });

                return groups;
            },
            []);

        if (this.showDateInputMacros())
        {

            let dateInputGroup = groupedShortcuts.find(x => x.name === ShortcutGroupKey.DateInput);
            if (!dateInputGroup)
            {
                dateInputGroup = {
                    name: ShortcutGroupKey.DateInput,
                    shortcuts: []
                };
                groupedShortcuts.push(dateInputGroup);
            }

            dateInputGroup.shortcuts.push(...dateInputKeys);
        }

        groupedShortcuts.sort((a, b) =>
        {
            return a.name === b.name
                ? 0
                : rank(a) - rank(b);
        });

        this.groupedShortcuts = groupedShortcuts;
    }

    /**
     * @deprecated - We should not have to inspect the DOM for anything that is not a direct child element of this component.#omniProfile
     */
    // FIXME - MetadataInputDate should register/unregister it's shortcuts in it's OnInit and OnDestroy.
    private showDateInputMacros(): boolean
    {
        return !!this.document.querySelector("metadata-input-date");
    }

    onCloseClick(_$event: Event): void
    {
        this.dialogRef.close();
    }

    /** @deprecated - the hell is this doing here???? */
    private getKey(index: number): string
    {
        const ret = Object.keys(Key)
            .filter(x => Key[x] === index);
        return ret[0] ?? "";
    }

    /** @deprecated - the hell is this doing here???? */
    private getModifier(index: number): string
    {
        const ret = Object.keys(ModifierKey)
            .filter(x => ModifierKey[x] === index);
        return ret[0] ?? "";
    }
}

function rank(value: ShortcutGroup): number
{
    switch (value.name)
    {
        case ShortcutGroupKey.View:
            return 0;
        case ShortcutGroupKey.Action:
            return 1;
        case ShortcutGroupKey.ActionMenu:
            return 2;
        case ShortcutGroupKey.Stepper:
            return 3;
        case ShortcutGroupKey.Global:
            return 4;
        case ShortcutGroupKey.DateInput:
            return 5;
        case ShortcutGroupKey.Dialog:
        default:
            return 6;
    }
}
